
<template>
	<div class = "keyword_nav_container">
		<ul class="nav nav-tabs">
			<li>
				<a class="nav-link" @click="setTab('sync')" :class = "currentPage == 'sync' ? 'active' : ''">Synced</a>
			</li>
			<li>
				<a class="nav-link" @click="setTab('non_sync')" :class = "currentPage == 'non_sync' ? 'active' : ''">Non-Synced</a>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
    name: 'KeyWordTabBar',
    data() {
        return {

        }
    },
	mounted(){
		console.log('rendered');
	},
	computed:{
		currentPage(){
			return this.$store.state.keywordCurrentTab
		}
	},
	methods:{
		setTab(val){
			this.$store.state.campaign.actionSelectionControl = false;
			this.$store.state.campaign.keyWordToTagList = [];
			this.$store.state.keywordCurrentTab = val
			this.$emit("currentType",val)
		}
	}
}
</script>

<style lang="scss">
.keyword_nav_container .nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active  {
        background: #3da3a7 !important;
        color: white !important;
        font-weight:550 !important;
        /* font-size: 18px; */
    }
</style>
